<template>
    <div class="card">
        <div class="card-header bg-gray">
            <h3 class="card-title"><i class="fab fa-telegram-plane mr-2"></i>Interna &nbsp;
            </h3>
               <div class="card-tools d-flex align-items-center" v-show="mostrarminimizaraux">
                            <button type="button" id="botonmin" class="btn btn-tool ampliar-asegurado" data-card-widget="collapse" @click="minimizarpulsar" title="Minimizar">
                    <i class="fas fa-eye"></i>
                </button>

                        </div>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <div class="col-md-6">
                            <label for="exampleInputEmail1">{{ $t('general.tipodeenvio') }}</label><br>
                            <select class="custom-select form-control-sm exampleInputEmail1 select2"  v-model="selected_tipo_envio">
                                <option value="INFOGENERALENVIAR">INFO ENVIADO</option> 
                                <option value="INFOGENERALRECIBIR">INFO RECIBIDO</option>                                    
                            </select>                             
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <label for="exampleInputEmail1">Mensaje</label><br>
                         <Editor editorStyle="height: 160px" v-model="cuerpo_mensaje">
                            </Editor>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                        <button class="btn btn-success btn-block" @click="enviarComunicacion()" type="button">{{
                            $t('general.enviar') }}</button>
                    </div>
            </div>
        </div>
    </div>
   
   
</template>
<script>
import { PwgsApi } from '../../../../../services/PwgsApi';
import Editor from 'primevue/editor';

export default ({
            props: ['id',  'servicio','minimizarprop'],
    setup() {
        return;
    },
    components: {
      Editor,
    },
      data() {
        return {
                    cuerpo_mensaje:'',
                    selected_tipo_envio:'INFOGENERALENVIAR',
                    repetiraux:0,


        }
    },
    methods: {
        async enviarComunicacion(){
            const api = new PwgsApi();
            let campos = {info: this.cuerpo_mensaje}
            let subidadatos = {tipo_mensaje: this.selected_tipo_envio,campos:campos} 
            try {
                await api.post('servicios/' + this.$props.id + '/comunicacion-sistema', subidadatos);
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Comunicacion enviada', life: 2000 });
                this.$parent.cargarmensajes();        
            }
            catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
   
            }
        
        },
         minimizarpulsar(){
            if(this.repetiraux==0){
                            this.$parent.$parent.minimizar();
                            this.repetiraux=1;

            }
            setTimeout(() => {
                this.repetiraux=0;
            }, 500);
        },
        
  
    },
    watch: {
       
        id(){
         },
         cargar(){
         },
         servicio(){
             
         },
         

    },
    mounted(){
        
            

        
    },
    activated(){
    },
     
})



</script>
